// extracted by mini-css-extract-plugin
export default {"button":"WOLGyj","label":"OWkw73","loading":"GYVojd"};